import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d1309ec")

_pushScopeId("data-v-6d1309ec")
const _hoisted_1 = { class: "main-bg" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_c_table = _resolveComponent("c-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_c_search_list, {
      inputList: _ctx.inputListComputed,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, null, 8, ["inputList", "onOnSearch", "onOnReset"]),
    _createVNode(_component_c_table, {
      dataSource: _ctx.tableConfig,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange,
      class: "mt30"
    }, null, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"])
  ]))
})